<template>
  <div class="input-container">
    <div class="row lg-flex-dir-col lg-width">
      <div class="col-12">
        <h2 class="pb-3">Dashboard / Recently Expired Subscriptions</h2>
      </div>
    </div>
    <div class="col-12 pl-0 pr-0 expiredsubbox">
      <div
        class="
          subsciptionbox
          recentsubscriptionbox
          theme--light
          v-card
          border-radius-4
        "
      >
        <div>
          <div class="pl-7 pt-5 pb-2 border-bottom">
            <h4 class="xs-fz-18 xs-pr-15">
              This shows subscriptions which have expired this month
            </h4>
          </div>

          <v-tabs
            v-model="tabs"
            background-color="transparent"
            class="border-bottom"
          >
            <v-tab
              @change="changeTab(item)"
              v-for="(item, i) in items"
              :key="i"
              >{{ item.tabName }}</v-tab
            >
          </v-tabs>

          <v-tabs-items v-model="tabs" class="pt-6">
            <!-- .......... doctor tab ......... -->
            <v-tab-item>
              <recent-expiry-lists
                :currentRole="role"
                v-if="tabs == 0"
              ></recent-expiry-lists>
            </v-tab-item>

            <!-- .......... pharmacy tab ......... -->
            <v-tab-item>
              <recent-expiry-lists
                :currentRole="role"
                v-if="tabs == 1"
              ></recent-expiry-lists>
            </v-tab-item>

            <!-- .......... diagnostic tab ......... -->
            <v-tab-item>
              <recent-expiry-lists
                :currentRole="role"
                v-if="tabs == 2"
              ></recent-expiry-lists>
            </v-tab-item>

            <!-- .......... blood bank tab ......... -->
            <v-tab-item>
              <recent-expiry-lists
                :currentRole="role"
                v-if="tabs == 3"
              ></recent-expiry-lists>
            </v-tab-item>

            <!-- .......... ambulance tab ......... -->
            <v-tab-item>
              <recent-expiry-lists
                :currentRole="role"
                v-if="tabs == 4"
              ></recent-expiry-lists>
            </v-tab-item>

            <!-- .......... allied tab ......... -->
            <v-tab-item>
              <recent-expiry-lists
                :currentRole="role"
                v-if="tabs == 5"
              ></recent-expiry-lists>
            </v-tab-item>

          </v-tabs-items>
        </div>
      </div>
    </div>

    <!-- <div class="row">
      <div class="col-12">
        <pagination
          class="mob-t-center pagination-block"
          :recordPerPage="recordPerPage"
          :total="total"
          @changePage="changePage"
        />
      </div>
    </div>-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { bus } from "@/main.js";
import { pickSvg } from "@/views/SVG";
const recentExpiryLists = () =>
  import("@/components/subscriptions/recentExpiryLists.vue");
export default {
  data() {
    return {
      tabs: null,
      items: [
        { tabName: "doctor" },
        { tabName: "pharmacy" },
        { tabName: "diagnostics-lab" },
        { tabName: "bloodbank" },
        { tabName: "ambulance" },
        { tabName: "allied" },
      ],
      role: "doctor",
    };
  },
  components: {
    ...pickSvg("chevronSVG"),
    recentExpiryLists,
  },
  computed: {
    ...mapGetters({
      permissions: "getPermissions",
    }),
  },

  methods: {
    changeTab(tab) {
      this.role = tab.tabName;
    },
  },
  mounted() {
    switch (this.$route.params.from) {
      case "doctor":
        this.tabs = 0;
        this.role = "doctor";
        break;
      case "pharmacy":
        this.tabs = 1;
        this.role = "pharmacy";
        break;
      case "diagnostics-lab":
        this.tabs = 2;
        this.role = "diagnostics-lab";
        break;
      case "bloodbank":
        this.tabs = 3;
        this.role = "bloodbank";
        break;
      case "ambulance":
        this.tabs = 4;
        this.role = "ambulance";
        break;
      case "allied":
        this.tabs = 5;
        this.role = "allied";
        break;
    }
  },
  created() {
    bus.$emit("CHAT_BREADCRUMB_CHANGE", [
      {
        text: "Home",
        disabled: !this.permissions.includes("VIEW_DASHBOARD"),
        to: "/",
      },
      {
        text: "Subscription Dashboard",
        disabled: false,
        to: "/subscription-dashboard",
      },
      {
        text: "Recently Expired Subscriptions",
        disabled: true,
        to: this.$route.path,
      },
    ]);
  },
};
</script>